import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vote-input__inputs" }
const _hoisted_2 = ["name", "value", "checked"]
const _hoisted_3 = ["name", "value", "checked"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vote-input", {'vote-input--selected': !!_ctx.modelValue}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.voteOnce || (_ctx.voteOnce && (!_ctx.modelValue || _ctx.modelValue === _ctx.positiveValue)))
        ? (_openBlock(), _createElementBlock("label", {
            class: _normalizeClass(["vote-input__label vote-input__label--positive", {
          'vote-input__label--checked': _ctx.modelValue === _ctx.positiveValue
        }]),
            key: `p`
          }, [
            _createElementVNode("input", {
              type: "radio",
              class: "vote-input__radio",
              name: _ctx.name,
              value: _ctx.positiveValue,
              checked: _ctx.modelValue === _ctx.positiveValue,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _cache[2] || (_cache[2] = _createTextVNode()),
      (!_ctx.voteOnce || (_ctx.voteOnce && (!_ctx.modelValue || _ctx.modelValue === _ctx.negativeValue)))
        ? (_openBlock(), _createElementBlock("label", {
            class: _normalizeClass(["vote-input__label vote-input__label--negative", {
          'vote-input__label--checked': _ctx.modelValue === _ctx.negativeValue
        }]),
            key: `n`
          }, [
            _createElementVNode("input", {
              type: "radio",
              class: "vote-input__radio",
              name: _ctx.name,
              value: _ctx.negativeValue,
              checked: _ctx.modelValue === _ctx.negativeValue,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createVNode(_Transition, { name: "input-error--animation" }, {
      default: _withCtx(() => [
        (!!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vote-input__error | input-error",
              innerHTML: _ctx.error
            }, null, 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 2 /* CLASS */))
}